import { A, C, CLICKS, ENTERS, INPUTS, KEYS } from './registry.js';
import { UI } from './store.js';
import { closeModal } from './ui.js';

// One set of delegated listeners for the whole app. Sections plug in through the registries.
export function initEvents() {
  document.addEventListener('click', (e) => {
    for (const h of CLICKS) if (h(e)) return;
    const el = e.target.closest('[data-act]');
    if (!el) return;
    const f = A[el.dataset.act];
    if (f) f(el, e);
  });
  document.addEventListener('keydown', (e) => {
    for (const h of KEYS) if (h(e)) return;
    if (e.key === 'Escape' && UI.modal) { closeModal(); return; }
    const en = e.target.closest && e.target.closest('[data-enter]');
    if (en && e.key === 'Enter') {
      e.preventDefault();
      const f = ENTERS[en.dataset.enter];
      if (f) f(en, en.value.trim());
      return;
    }
    const row = e.target.closest && e.target.closest('[role="button"][tabindex]');
    if (row && (e.key === 'Enter' || e.key === ' ') && e.target === row) { e.preventDefault(); row.click(); }
  });
  document.addEventListener('change', (e) => {
    const el = e.target.closest('[data-chg]');
    if (!el) return;
    const f = C[el.dataset.chg];
    if (f) f(el, e);
  });
  document.addEventListener('input', (e) => {
    const t = e.target;
    const k = t.dataset && t.dataset.inp;
    if (k && INPUTS[k]) INPUTS[k](t, e);
  });
}
